import { render } from "./Content_live.vue?vue&type=template&id=3d98f3e8&scoped=true"
import script from "./Content_live.vue?vue&type=script&lang=js"
export * from "./Content_live.vue?vue&type=script&lang=js"

import "./Content_live.vue?vue&type=style&index=0&id=3d98f3e8&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d98f3e8"]])